import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';
import { ContentService } from '../../content/content.service';

@Component({
  selector: 'app-questions-analysis-view',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslateModule, MarkdownModule],
  templateUrl: './questions-analysis-view.component.html',
  styleUrls: ['./questions-analysis-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionsAnalysisViewComponent implements OnInit {
  @Input() analysisResult: any;
  @Input() totalLength: number = 0;
  @Output() close = new EventEmitter<void>();

  private contentService = inject(ContentService);

  ngOnInit() {
    if (this.totalLength === 0) {
      this.contentService.getAIQuestions({ pageIndex: 0, pageSize: 1, query: '', showUnansweredOnly: false }).subscribe({
        next: (res) => {
          if (res?.totalCount?.[0]?.total) {
            this.totalLength = res.totalCount[0].total;
          }
        },
      });
    }
  }

  closeView() {
    this.close.emit();
  }
}
